import { Chart } from "@scuf/charts";
import { Card } from "@scuf/common";
import { useEffect, useState } from "react";
import { getConsolidadoPeriodo } from "../../../services/services";
import LoadingChart from "./loadingChart";
import formatDateType from "../../../utils/formatDateType";
import useYAxisTitle from "../../../hooks/useYAxisTitle";

export default function TratamientoConcentradoBs(props) {
  const SECUENCIA = 2;

  // Objeto por default de los states
  const defaultObject = Object.assign({
    value: [],
    fecha: [],
  });

  const [yAxisTitleLeft, yAxisTitleRight] = useYAxisTitle(props.periodo);

  const [totalizadorTurno, setToralizadorTurno] = useState(defaultObject);
  const [planSemanal, setPlanSemanal] = useState(defaultObject);
  const [planMensual, setPlanMensual] = useState(defaultObject);
  const [pOAnio, setPOAnio] = useState(defaultObject);
  //Totalizador semana
  const [valorSemanaTotalizador, setValorSemanaTotalizador] =
    useState(defaultObject);
  //Totalizador mes
  const [valorMesTotalizador, setValorMesTotalizador] = useState(defaultObject);
  //Totalizador Año
  const [valorAnioTotalizador, setValorAnioTotalizador] =
    useState(defaultObject);
  //Loading
  const [isLoading, setIsLoading] = useState(true);

  // Efecto que se ejecturara cada vez que cambien las props
  useEffect(() => {
    async function fetchData() {
      setIsLoading(true);

      const { data } = await getConsolidadoPeriodo({
        secuencia: SECUENCIA,
        periodo: props.periodo,
      });

      populateTotalizadorTurno(data);
      populateTotalizadorSemana(data);
      populateTotalizadorMes(data);
      populateTotalizadorAnio(data);

      populatePlanSemanal(data);
      populatePlanMensual(data);
      populatePO(data);

      setIsLoading(false);
    }

    fetchData();
  }, [props]);

  function populatePO(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "P0 (año): Tratamiento"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorAgno);
      arrFechas.push(element.fecha);
    });

    setPOAnio({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePlanMensual(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Plan mensual: Tratamiento"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorMes);
      arrFechas.push(element.fecha);
    });

    setPlanMensual({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populatePlanSemanal(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Plan semanal: Tratamiento"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorSemana);
      arrFechas.push(element.fecha);
    });

    setPlanSemanal({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorTurno(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Tratamiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.Valor);
      arrFechas.push(element.fecha);
    });

    setToralizadorTurno({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorSemana(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Tratamiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorSemana);
      arrFechas.push(element.fecha);
    });

    setValorSemanaTotalizador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorMes(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Tratamiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorMes);
      arrFechas.push(element.fecha);
    });

    setValorMesTotalizador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  function populateTotalizadorAnio(data) {
    const arrValues = [];
    const arrFechas = [];

    const arrData = data.filter(
      (element) => element.Detalle === "Totalizador Tratamiento: Turno"
    );

    arrData.forEach((element) => {
      arrValues.push(element.ValorAgno);
      arrFechas.push(element.fecha);
    });

    setValorAnioTotalizador({
      fecha: arrFechas,
      value: arrValues,
    });
  }

  return (
    <>
      {isLoading ? (
        <LoadingChart />
      ) : (
        <Card>
          <Card.Content>
            <Chart
              title="Tratamiento Concentrado bs"
              series={{
                boostThreshold: 1,
              }}
            >
              {props.periodo !== "A" ? (
                <Chart.Column
                  name={`Totalizador Tratamiento:  ${yAxisTitleLeft} `}
                  data={totalizadorTurno.value}
                />
              ) : (
                <></>
              )}

              {props.periodo === "S" || props.periodo === "M" ? (
                <Chart.Column
                  name="Totalizador Tratamiento: Semana"
                  data={valorSemanaTotalizador.value}
                  yAxis={1}
                />
              ) : (
                <></>
              )}

              {props.periodo === "M" || props.periodo === "A" ? (
                <Chart.Column
                  name="Totalizador Tratamiento: Mes"
                  data={valorMesTotalizador.value}
                  yAxis={1}
                />
              ) : (
                <></>
              )}

              {props.periodo === "A" ? (
                <Chart.Column
                  name="Totalizador Tratamiento: Año"
                  data={valorAnioTotalizador.value}
                  yAxis={1}
                />
              ) : (
                <></>
              )}

              {props.periodo === "M" ? (
                <Chart.Line
                  name="Plan semanal: Tratamiento"
                  data={planSemanal.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {/* Plan mensual solo debe mostrar cuando la props sea M */}
              {props.periodo === "M" ? (
                <Chart.Line
                  name="Plan mensual: Tratamiento"
                  data={planMensual.value}
                  yAxis={0}
                />
              ) : (
                <></>
              )}

              {/* Plan mensual solo debe mostrar cuando la props sea A */}
              {props.periodo === "A" ? (
                <Chart.Line name="P0 (año): Tratamiento" data={pOAnio.value} />
              ) : (
                <></>
              )}

              <Chart.XAxis
                categories={
                  props.periodo === "S"
                    ? formatDateType(planSemanal.fecha, "S")
                    : props.periodo === "M"
                    ? formatDateType(planSemanal.fecha, "M")
                    : formatDateType(planSemanal.fecha, "A")
                }
              />

              <Chart.YAxis
                labelSuffix=" t. bs."
                title={`Totalizador ${yAxisTitleLeft} bs, t`}
                lineWidth={2}
                lineColor="white"
              />

              <Chart.YAxis
                labelSuffix=" t. bs."
                title={`Totalizador ${yAxisTitleRight} bs, t`}
                lineWidth={2}
                lineColor="white"
                opposite={true}
              />

              <Chart.Tooltip valueSuffix=" t. bs." />
            </Chart>
          </Card.Content>
        </Card>
      )}
    </>
  );
}
